module.exports = __webpack_public_path__ + "img/no_complete.3e746a39.png";